var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "body-loader" } },
    [
      _vm.violatingCopyright
        ? _c("vs-error-page", {
            attrs: {
              heading: "Copyright Violation",
              message:
                "This collection has been removed in response to a report of potential infringement of intellectual property rights and is no longer taking orders."
            }
          })
        : _vm.disabled
        ? _c("vs-error-page", {
            attrs: {
              heading: "Collection Offline",
              message: "This collection has been disabled by the creator."
            }
          })
        : _vm.ready
        ? _c("collection", {
            attrs: {
              "route-name": "collection",
              info: _vm.info,
              campaigns: _vm.campaigns,
              "currency-info": _vm.currencyInfo,
              page: _vm.page,
              "is-whitelabel": _vm.isWhitelabel,
              processing: _vm.processing,
              "sort-options": _vm.sortOptions,
              "selected-sort-text": _vm.collectionSelectedSortText,
              "selected-product-type": _vm.selectedProductType,
              "formatted-product-type": _vm.collectionFormattedProductType,
              "product-types": _vm.collectionProductTypes,
              pages: _vm.collectionPages,
              "max-pages": _vm.maxPages,
              "is-user-admin": _vm.isUserAdmin,
              "show-sort-and-filter": _vm.info.enable_sort_and_filter,
              "alternate-image": _vm.isWhitelabel
                ? _vm.domainConfig.assets.banner
                : null,
              coupon: _vm.$route.query.coupon,
              "show-mobile-filter-modal": _vm.showMobileFilterModal,
              "show-mobile-sort-modal": _vm.showMobileSortModal
            },
            on: {
              "view-collection": _vm.handleViewCollection,
              "update-state": _vm.handleUpdateState,
              "get-campaigns": _vm.handleGetCampaigns,
              "lock-scroll": _vm.handleLockScroll
            }
          })
        : _vm.notFound
        ? _c("vs-error-page", {
            attrs: {
              heading: "404 Collection Not Found",
              message:
                "This collection does not exist or the URL has been changed by the creator."
            }
          })
        : _c("div", { staticClass: "body-padding" }, [
            _c("img", {
              staticClass: "opacity-100 mx-auto",
              attrs: { src: _vm.loadingGif, alt: "loading" }
            })
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }